import { produce } from 'immer'

// Action Types
export const SET_SETTINGS = 'userSettings/setSettings'
export const SET_SETTING = 'userSettings/setSetting'
export const SET_LOADING = 'userSettings/setLoading'
export const SET_SAVING = 'userSettings/setSaving'

// Action Creators
export const setSettings = (payload) => ({ type: SET_SETTINGS, payload })
export const setSetting = (payload) => ({ type: SET_SETTING, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const setSaving = (payload) => ({ type: SET_SAVING, payload })

// State
export const initialState = {
  settings: {},
  loaded: false,
  loading: false,
  saving: false,
}

// Reducer
export default function userSettingsReducer(state = initialState, action) {
  return produce(state, (newState) => {
    const { payload } = action

    switch (action.type) {
      case SET_SETTINGS:
        newState.settings = payload
        newState.loaded = true
        break
      case SET_SETTING:
        newState.settings[payload.accessor] = payload.value
        break
      case SET_LOADING:
        newState.loading = payload
        break
      case SET_SAVING:
        newState.saving = payload
        break
      default:
        break
    }
  })
}
